import { z } from 'zod'

export enum CookieCategory {
  Essential = 'essential',
  Analytics = 'analytics',
  Marketing = 'marketing',
}

const cookieConsentPermissionsSchema = z.object({
  category: z.enum(CookieCategory),
  excluded: z.array(z.string()).optional(),
})

export type CookieConsentPermissions = z.infer<
  typeof cookieConsentPermissionsSchema
>

export const cookieConsentSchema = z.object({
  prompted: z.boolean(),
  datestamp: z.string(),
  permissions: z.array(cookieConsentPermissionsSchema),
  version: z.string().optional(),
})

export type CookieConsent = z.infer<typeof cookieConsentSchema>
